//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Border from './_border'
export default {
    components: {
        Border
    },
    props: {
        other_style: Object,
        title: String,
        more_text: String,
        show_more_icon: {
            type: Boolean,
            default: true
        },
        is_longer: Boolean
    }
}
